import "../GlobalSpinner/GlobalSpinner.scss"

function GlobalSpinner({style}){
    return <div className="spinner" style={style}/>
}
export default GlobalSpinner
